module.exports = __webpack_public_path__ + "media/images/edion/top/8-acff93274d5e916f13198f9d94c9f3ce.png";